module.exports = __webpack_public_path__ + "media/images/common/hakuoshi_gold-eca3a641d41d228678b039d86d3af528.jpg";